import { Injectable } from "@angular/core";
import { AppConfig } from "../configs/app";

@Injectable({
  providedIn: "root",
})
export class CacheService {
  constructor(public appConfig: AppConfig) {}

  getData(key: any, ttl: any): any {
    /* TO DO */
    if (key) {
      let data: any = localStorage.getItem(
        this.appConfig.localStorageCachePrefixName + key
      );
      data = JSON.parse(data);
      /* CHECK EXPIRED */
      if (data !== null && data.createdAt + ttl < new Date().getTime()) {
        this.removeData(key);
      }
      return data !== null ? data : null;
    }
    return null;
  }

  setData(key: any, data: any) {
    if (key) {
      data.createdAt = new Date().getTime();
      localStorage.setItem(
        this.appConfig.localStorageCachePrefixName + key,
        JSON.stringify(data)
      );
    }
  }

  removeData(key: any = "") {
    localStorage.removeItem(this.appConfig.localStorageCachePrefixName + key);
  }
}
